import secureLocalStorage from "react-secure-storage";
import React, { PureComponent } from "react";
import "../../Styles/RiskViews.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import * as moment from "moment";
import ValidateNumberCell from "./ValidateNumberCell";
export default class ValidateActivity extends PureComponent {
  constructor(props) {
    super(props);
    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: 20,
      skip: 0,
      validateData: [],
    });
  }
  componentDidMount() {
    this.GetTemporaryTaskActionsListForUploader();
  }

  GetTemporaryTaskActionsListForUploader = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      const requestParams = {
        workstreamId: this.props.workstreamId,
      };
      let response = await Api.GetTemporaryTaskActionsListForUploader(
        requestParams
      );
      if (response.status === 200) {
        response.taskActionResponses.map((riskReg) => {
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        this.props.handleValidateDataCount({
          newTaskCount: response.newTaskActionCount,
          modifiedTaskCount: response.modifiedTaskActionCount,
          closedTaskCount: response.closedTaskActionCount
        });
        this.setState({
          ...this.state,
          validateData: response.taskActionResponses,
          validateDataTemp: response.taskActionResponses,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, loader: false });
        this.props.handleValidateDataCount({
          newTaskCount: response.newTaskActionCount,
          modifiedTaskCount: response.modifiedTaskActionCount,
          closedTaskCount: response.closedTaskActionCount
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ ...this.state, loader: false });
    }
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  createAppState = (dataState) => {
    if (this.state && this.state.validateDataTemp) {
      return {
        validateData: this.state.validateDataTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        validateData: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => { };
  validate_rowRender = (row, rowProps) => {
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    if (rowProps.dataItem.isUncommit === true) {
      backgroundColor = "#301934";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(rowProps.dataItem.isClosedExcelUpdate === true) {
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";

    // }

    return React.cloneElement(
      row,
      {
        ...row.props,
        style: {
          ...row.props.style,
          backgroundColor: backgroundColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        },
      },
      row.props.children
    );
  };
  validate_cellRender = (row, cellProps) => {
    const cellField = cellProps.field;
    var dataItem = cellProps.dataItem;
    const cellValue = dataItem[cellField];
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    if (
      dataItem.updatedColumnsFromExcel &&
      dataItem.updatedColumnsFromExcel.includes(cellField)
    ) {
      backgroundColor = "#034f0e";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(dataItem.isClosedExcelUpdate===true && cellField==='taskActionNumber'){
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";
    // }
    if (this.checkDate(cellValue)) {
      dataItem[cellField] = cellValue
        ? moment(cellValue).format("DD-MMM-YYYY")
        : "";
    }
    return React.cloneElement(
      row,
      {
        ...row.props,
        style: {
          ...row.props.style,
          backgroundColor: backgroundColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        },
      },
      row.props.children
    );
  };
  checkDate = (dateString) => {
    if (dateString && dateString != "") {
      return moment(dateString, "DD-MMM-YYYY", true).isValid();
    }
    return false;
  };
  render() {
    return (
      <div
        className="tblCont riskRegister dataGrids reportsGrid"
        id="reportaction"
      >
        {this.props.loader || this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <Grid
          data={process(this.state.validateData, this.state.dataState)}
          {...this.state.dataState}
          onDataStateChange={this.dataStateChange}
          rowRender={this.validate_rowRender}
          cellRender={this.validate_cellRender}
          reorderable
          resizable
          sortable={true}
          pageable={true}
        >
          <Column field="taskActionNumber" title="Activity Number" width="200px" locked={true}
            cell={ValidateNumberCell} />

          <Column
            field="taskActionTitle"
            title="Activity Title"
            width="200px"
          />
          <Column
            field="taskNumber"
            title="Task Number"
            width="200px"
          />
          <Column field="taskTitle" title="Task Title" width="200px" />
          <Column
            field="isApproved"
            title="Approved"
            width="200px"
          />
          <Column
            field="taskActionDescription"
            title="Activity Description"
            width="200px"
          />
          <Column
            field="cost"
            title={
              "Cost of Activity" + " (" + secureLocalStorage.getItem("currency") + ")"
            }
            width="200px"
          />
          <Column
            field="effort"
            title={"Effort" + " (Days)"}
            filter={"numeric"}
            width="200px"
          />
          <Column
            field="percentageOnTrack"
            title="% on Track"
            width="200px"
            filter={"numeric"}
          />
          <Column
            field="percentageCompletion"
            title="% Completion"
            width="200px"
            filter={"numeric"}
          />
          <Column
            field="priorityRankingName"
            title="Priority Ranking"
            width="200px"
          />
          <Column
            field="priorityScore"
            title="Weighted Priority"
            width="200px"
          />
          <Column
            field="progressComment"
            title="Progress Status"
            width="200px"
          />
          {/* {this.state.dropdownColumns} */}
          <Column
            field="originalCompletionDate"
            title="Original Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="projectedCompletionDate"
            title="Projected Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="actualCompletionDate"
            title="Actual Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="proximityAlertDate"
            title="Proximity Alert Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="delayConsequence"
            title="Delay Consequence"
            width="200px"
          />
          <Column
            field="alertStakeHolders"
            title="Alert Stakeholders"
            width="200px"
          />
          <Column
            field="alertDescription"
            title="Alert Description"
            width="200px"
          />
          <Column field="ownerName" title="Activity Owner" width="200px" />
          <Column
            field="createdDate"
            title="Created Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column field="createdByName" title="Created By" width="200px" />
          <Column
            field="updatedDate"
            title="Updated Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column field="updatedByName" title="Updated By" width="200px" />
          <Column
            field="closedDate"
            title="Closed Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column field="isClosed" title="Status" width="200px" />

          <Column
            field="departments"
            title="Departments"
            width="150px"
          />
          <Column
            field="externalStatus"
            title="External Status"
            width="120px"
          />
          <Column
            field="weeklyReport"
            title="Weekly Report"
            width="100px"
          />
        </Grid>
      </div>
    );
  }
}
